jQuery( function ( $ ) {
  // taken and modified from https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/Roles/Tab_Role

  $( 'section.tabbed-forms' ).each( function () {
    const $section = $(this)

    // tab functionality for desktop
    const $tablist = $( '[role=tablist]', $section )
    const $tabs = $( '[role=tab]', $tablist )
    const $tabpanel_wrap = $( '.tabpanel-wrap', $section )
    const $tab_panels = $( '[role=tabpanel]', $section )
    const active_btn_var = $section.data( 'btn-active' )
    const inactive_btn_var = $section.data( 'btn-inactive' )
    let tab_focus = 0

    if ( $tabs.length < 2 ) { return }

    $tablist
      .on( 'click', 'button[role=tab]', function () {
        const uniqid = $(this).data( 'uniqid' )
        select_tab( uniqid )
        // $accordion_toggles.each( function () {
        //   AccordionGroup.toggle_item( this, $(this).data( 'uniqid' ) == uniqid )
        // })
      })
      .on( 'keydown', function ( e ) {
        if ( [ 37, 38, 39, 40 ].includes( e.keyCode ) ) {
          e.preventDefault()
          $tabs.eq( tab_focus ).attr( "tabindex", -1 )

          if ( [ 39, 40 ].includes( e.keyCode ) ) {
            // Move right
            tab_focus = ( tab_focus + 1 ) % $tabs.length
          } else {
            // Move left
            tab_focus = ( tab_focus - 1 ) % $tabs.length
          }
  
          $tabs.eq( tab_focus ).attr( "tabindex", 0 )
          $tabs.eq( tab_focus ).focus()
        }
      })

    $tabpanel_wrap.on( 'init afterChange', function ( e, slick, index ) {
      slick.initADA()
      slick.$slides.filter( '.slick-active' ).removeAttr( 'tabindex' )
    })

    $tabpanel_wrap.slick({
      dots: false,
      arrows: false,
      fade: true,
      adaptiveHeight: true,
      draggable: false,
      accessibility: false,
      waitForAnimate: false,
      rows: 0,
    })

    
    function select_tab ( uniqid ) {
      $tabs.each( function () {
        const $tab = $(this)
        const is_selected = $tab.data( 'uniqid' ) == uniqid
        $tab
          .attr( 'aria-selected', is_selected )
          .toggleClass( `btn-${ active_btn_var }`, is_selected )
          .toggleClass( `btn-${ inactive_btn_var }`, !is_selected )
      })
      $tabpanel_wrap.slick( 'slickGoTo', $tab_panels.filter(`[data-uniqid=${ uniqid }]`).data( 'slick-index' ) )
    }
  })

})